
import Tabs from './packages/tabs/index.js'
const components = [
    Tabs
];
// 替换element组件
const install = (Vue) => {
    components.forEach(component => {
        Vue.component(component.name, component);
    });
};
// 浏览器环境直接挂载插件
if (typeof window !== 'undefined' && window.Vue) {
    console.log('window--', window)
    install(window.Vue)
}
export default {
    install,
    Tabs   
}
